/**
 * Supported profile/account types (broker account type removed — maps to business).
 */
export type ProfileType = 'tenant' | 'landlord' | 'business';

export function normalizeProfileType(value?: string | null): ProfileType {
  if (!value) return 'tenant';
  const lower = value.toLowerCase();
  if (lower === 'broker') return 'business';
  if (lower === 'tenant' || lower === 'landlord' || lower === 'business') {
    return lower;
  }
  return 'tenant';
}

export function isProviderProfile(value?: string | null): boolean {
  const t = normalizeProfileType(value);
  return t === 'landlord' || t === 'business';
}
